export const CASES = '#cases'
export const ABOUT = '#about'
export const SERVICES = '#services'
export const CONTACT ='#contact'